export enum DqePhoneTypeEnum {
  MOBILE = 'MOBILE',
  FIXE = 'FIXED_LINE',
  EMPTY = ''
}
